(function () {
  if (window.innerWidth < 750) return;

  var takeover = document.getElementById('product-gallery-takeover');
  var gallery = document.querySelector('[data-product-gallery]');
  if (!takeover || !gallery) return;

  document.body.appendChild(takeover);

  var backdrop = takeover.querySelector('[data-takeover-backdrop]');
  var flyout = takeover.querySelector('[data-takeover-flyout]');
  var heroImg = takeover.querySelector('[data-takeover-img]');
  var countEl = takeover.querySelector('[data-takeover-count]');
  var thumbBtns = takeover.querySelectorAll('[data-takeover-thumb-index]');
  var contentEl = takeover.querySelector('[data-takeover-content]');

  var galleryItems = gallery.querySelectorAll('.product__gallery-item');
  var sources = [];

  galleryItems.forEach(function (el) {
    sources.push({
      src: el.getAttribute('data-gallery-src'),
      el: el
    });
  });

  var total = sources.length;
  var current = 0;
  var isOpen = false;
  var openTimeline = null;
  var sourceImgEl = null;
  var smoother = typeof ScrollSmoother !== 'undefined' ? ScrollSmoother.get() : null;
  var savedScrollTop = 0;
  var stickyHeader = document.querySelector('sticky-header');
  var sectionHeader = document.querySelector('.section-header');

  function updateUI(idx) {
    current = idx;
    countEl.textContent = (idx + 1) + ' / ' + total;
    thumbBtns.forEach(function (btn) {
      btn.classList.toggle('is-active', parseInt(btn.getAttribute('data-takeover-thumb-index'), 10) === idx);
    });
  }

  function positionImage() {
    flyout.style.overflowY = 'hidden';
    var imgH = heroImg.offsetHeight;
    var vpH = flyout.clientHeight;
    heroImg.style.marginTop = '';
    if (imgH > vpH) {
      flyout.scrollTop = (imgH - vpH) / 2;
    } else {
      heroImg.style.marginTop = ((vpH - imgH) / 2) + 'px';
    }
    flyout.style.overflowY = 'auto';
  }

  function open(idx, clickedImg) {
    if (idx < 0 || idx >= total || isOpen) return;
    isOpen = true;

    var rect = clickedImg.getBoundingClientRect();
    var vw = window.innerWidth;
    var vh = window.innerHeight;

    sourceImgEl = clickedImg;
    heroImg.src = clickedImg.currentSrc || clickedImg.src;

    takeover.classList.add('is-open');
    takeover.setAttribute('aria-hidden', 'false');
    updateUI(idx);

    gsap.set(backdrop, { opacity: 0 });
    gsap.set(contentEl, { opacity: 0 });

    gsap.set(flyout, {
      left: rect.left,
      top: rect.top,
      width: rect.width,
      height: rect.height,
      borderRadius: 0,
      clearProps: 'transform,transformOrigin,scale'
    });

    document.body.classList.add('takeover-open');
    if (smoother) {
      savedScrollTop = smoother.scrollTop();
      smoother.paused(true);
      smoother.scrollTop(savedScrollTop);
    }
    if (stickyHeader && stickyHeader.onScrollHandler) {
      window.removeEventListener('scroll', stickyHeader.onScrollHandler);
    }
    if (sectionHeader) {
      sectionHeader.classList.remove('shopify-section-header-hidden');
      sectionHeader.classList.add('shopify-section-header-sticky');
    }

    var hiRes = new Image();
    hiRes.src = sources[idx].src;

    if (openTimeline) openTimeline.kill();
    openTimeline = gsap.timeline({
      onComplete: function () {
        flyout.classList.add('is-expanded');
        positionImage();
        if (hiRes.complete) {
          heroImg.src = hiRes.src;
          positionImage();
        } else {
          hiRes.onload = function () {
            heroImg.src = hiRes.src;
            positionImage();
          };
        }
        openTimeline = null;
      }
    });

    openTimeline
      .to(backdrop, { opacity: 1, duration: 0.4, ease: 'power2.out' }, 0)
      .to(flyout, {
        left: 0,
        top: 0,
        width: vw,
        height: vh,
        duration: 0.6,
        ease: 'power3.inOut'
      }, 0)
      .to(contentEl, { opacity: 1, duration: 0.3, ease: 'power1.out' }, 0.45);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;

    if (openTimeline) openTimeline.kill();

    var target = sourceImgEl || (sources[current] ? sources[current].el.querySelector('img') : null);
    var rect = (target && target.offsetParent !== null) ? target.getBoundingClientRect() : null;
    sourceImgEl = null;
    var imgH = heroImg.offsetHeight;
    var vpH = flyout.clientHeight;
    var centeredScroll = imgH > vpH ? (imgH - vpH) / 2 : 0;
    var needsScroll = Math.abs(flyout.scrollTop - centeredScroll) > 2;

    function animateOut() {
      flyout.classList.remove('is-expanded');
      heroImg.style.marginTop = '';

      var tl = gsap.timeline({
        onComplete: function () {
          takeover.classList.remove('is-open');
          takeover.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('takeover-open');
          if (smoother) {
            smoother.paused(false);
            smoother.scrollTop(savedScrollTop);
          }
          if (stickyHeader && stickyHeader.onScrollHandler) {
            window.addEventListener('scroll', stickyHeader.onScrollHandler, false);
          }
          gsap.set(flyout, { clearProps: 'all' });
          gsap.set(heroImg, { clearProps: 'all' });
          gsap.set(backdrop, { clearProps: 'all' });
          gsap.set(contentEl, { clearProps: 'all' });
        }
      });

      tl.to(contentEl, { opacity: 0, duration: 0.15, ease: 'power1.in' }, 0);

      if (rect) {
        heroImg.src = target.currentSrc || target.src;
        tl.to(flyout, {
          left: rect.left,
          top: rect.top,
          width: rect.width,
          height: rect.height,
          duration: 0.5,
          ease: 'power3.inOut'
        }, 0);
        tl.to(backdrop, { opacity: 0, duration: 0.4, ease: 'power2.in' }, 0.1);
      } else {
        tl.to(flyout, { opacity: 0, duration: 0.3 }, 0);
        tl.to(backdrop, { opacity: 0, duration: 0.3 }, 0);
      }
    }

    if (needsScroll) {
      gsap.to(flyout, {
        scrollTop: centeredScroll,
        duration: 0.25,
        ease: 'power2.inOut',
        onComplete: animateOut
      });
      gsap.to(contentEl, { opacity: 0, duration: 0.2, ease: 'power1.in' });
    } else {
      animateOut();
    }
  }

  function switchTo(idx) {
    if (idx === current || idx < 0 || idx >= total) return;
    current = idx;
    updateUI(idx);
    var el = sources[idx] ? sources[idx].el : null;
    sourceImgEl = (el && el.offsetParent !== null) ? el.querySelector('img') : null;

    var preload = new Image();
    preload.src = sources[idx].src;

    function doSwap() {
      heroImg.src = preload.src;
      positionImage();
    }

    if (preload.complete) {
      doSwap();
    } else {
      preload.onload = doSwap;
    }
  }

  galleryItems.forEach(function (itemEl, i) {
    var img = itemEl.querySelector('img');
    if (!img) return;
    itemEl.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      open(i, img);
    });
  });

  backdrop.addEventListener('click', close);

  flyout.addEventListener('click', function (e) {
    if (e.target.closest('[data-takeover-content]')) return;
    close();
  });

  thumbBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      switchTo(parseInt(btn.getAttribute('data-takeover-thumb-index'), 10));
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) close();
  });

  var closeCursor = document.createElement('div');
  closeCursor.className = 'product-gallery-takeover__cursor';
  closeCursor.innerHTML = '<svg width="40" height="15" viewBox="0 0 40 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M39.5554 14.144H36.8354V13.712C38.5314 13.552 38.5794 13.488 38.5794 12.224V2.19202C38.5794 0.944024 38.5314 0.864024 36.8354 0.720024V0.288025H39.5554V14.144Z" fill="#FF4A09"/><path d="M35.4624 9.95202C34.3104 11.328 33.1264 11.728 32.2944 11.728C31.5744 11.728 30.5664 11.312 30.5664 9.39202C30.5664 7.96802 31.1584 6.22402 32.4224 5.28002C33.0784 4.80002 33.8784 4.46402 34.5024 4.46402C35.3184 4.46402 35.7824 5.02402 35.7824 5.66402C35.7824 7.18402 33.5744 7.92002 31.7984 8.27202C31.7824 8.49602 31.7664 8.83202 31.7664 8.97602C31.7664 9.90402 32.0384 10.864 33.0304 10.864C33.7024 10.864 34.5024 10.448 35.2704 9.63202L35.4624 9.95202ZM33.8784 5.08802C33.2864 5.08802 32.2784 5.56802 31.8624 7.80802C34.1344 7.42402 34.6944 6.65602 34.6944 5.88802C34.6944 5.40802 34.4064 5.08802 33.8784 5.08802Z" fill="#FF4A09"/><path d="M28.4017 4.46402C29.0737 4.46402 29.5698 4.84802 29.5698 5.26402C29.5698 5.52002 29.3298 5.88802 29.0898 5.96802C28.9618 6.00002 28.8818 5.93602 28.7218 5.77602C28.3698 5.39202 28.0177 5.18402 27.6497 5.18402C27.1857 5.18402 26.7538 5.56802 26.7538 6.14402C26.7538 6.70402 27.2338 7.05602 27.8258 7.53602C28.7698 8.28802 29.0898 8.72002 29.0898 9.34402C29.0898 10.56 27.4258 11.728 26.2258 11.728C25.5058 11.728 24.8177 11.232 24.8177 10.704C24.8177 10.384 25.1538 9.96802 25.4098 9.95202C25.5058 9.93602 25.5538 9.98402 25.6338 10.08C26.0818 10.704 26.5457 10.992 27.0257 10.992C27.6337 10.992 28.1138 10.528 28.1138 9.96802C28.1138 9.56802 27.9538 9.20002 27.2178 8.59202C26.5298 8.03202 25.8737 7.56802 25.8737 6.76802C25.8737 6.30402 26.0498 5.77602 26.6898 5.23202C27.1538 4.81602 27.8577 4.46402 28.4017 4.46402Z" fill="#FF4A09"/><path d="M22.1594 4.46402C23.4394 4.46402 24.2074 5.34402 24.2074 6.86402C24.2074 8.59202 23.3274 10.272 21.9674 11.136C21.4074 11.488 20.7994 11.728 20.1274 11.728C18.6874 11.728 18.0954 10.576 18.0954 9.31202C18.0954 7.18402 19.2474 5.56802 20.6074 4.88002C21.1034 4.62402 21.6954 4.46402 22.1594 4.46402ZM21.6314 5.04002C19.9834 5.04002 19.3434 7.50402 19.3434 9.13602C19.3434 10.384 19.8394 11.136 20.6874 11.136C22.2714 11.136 22.9594 8.54402 22.9594 6.94402C22.9594 5.63202 22.3994 5.04002 21.6314 5.04002Z" fill="#FF4A09"/><path d="M16.8276 9.84L17.0036 10.144C16.2356 11.2 15.3076 11.728 14.8756 11.728C14.4756 11.728 14.2836 11.36 14.5876 9.952C15.1476 7.216 15.8036 4.176 16.2996 1.744C16.4436 1.008 16.3796 0.943999 15.7876 0.88C15.6276 0.863999 15.4036 0.848 15.2596 0.848L15.3396 0.512C16.0916 0.415999 16.7796 0.271999 17.2276 0.112C17.4836 0.0159998 17.5636 0 17.6436 0C17.7716 0 17.7876 0.112 17.7076 0.464C16.9876 3.584 16.0756 7.872 15.6436 10.096C15.5476 10.512 15.5956 10.656 15.7076 10.656C15.8836 10.656 16.3156 10.4 16.8276 9.84Z" fill="#FF4A09"/><path d="M12.5237 9.04002L12.8597 9.20002C12.6677 9.77602 12.1237 11.04 11.8837 11.44C11.4037 11.52 10.3957 11.776 9.30766 11.776C6.57166 11.776 4.66766 10.144 4.66766 7.18402C4.66766 3.56802 7.49966 0.912018 11.0997 0.912018C12.4117 0.912018 13.3237 1.16802 13.8197 1.31202C13.7077 1.82402 13.5957 2.78402 13.4997 3.66402L13.1157 3.68002C13.0837 1.77602 12.2197 1.40802 10.7637 1.40802C7.91566 1.40802 6.09167 4.20802 6.09167 7.18402C6.09167 9.48802 7.16366 11.296 9.40366 11.296C10.9717 11.296 11.7717 10.32 12.5237 9.04002Z" fill="#FF4A09"/><path d="M2.72 14.144H0V0.288025H2.72V0.736025C1.024 0.864024 0.976006 0.944024 0.976006 2.19202V12.24C0.976006 13.488 1.008 13.552 2.72 13.696V14.144Z" fill="#FF4A09"/></svg>';
  document.body.appendChild(closeCursor);

  var mouseX = 0, mouseY = 0;
  var lerpX = 0, lerpY = 0;
  var cursorVisible = false;
  var rafId = null;
  var ease = 0.12;

  function tickCursor() {
    lerpX += (mouseX - lerpX) * ease;
    lerpY += (mouseY - lerpY) * ease;
    closeCursor.style.transform = 'translate(' + lerpX + 'px, ' + lerpY + 'px)';
    if (cursorVisible) {
      rafId = requestAnimationFrame(tickCursor);
    }
  }

  function showCursor() {
    if (cursorVisible) return;
    cursorVisible = true;
    lerpX = mouseX;
    lerpY = mouseY;
    closeCursor.classList.add('is-visible');
    rafId = requestAnimationFrame(tickCursor);
  }

  function hideCursor() {
    if (!cursorVisible) return;
    cursorVisible = false;
    closeCursor.classList.remove('is-visible');
    if (rafId) cancelAnimationFrame(rafId);
  }

  takeover.addEventListener('mousemove', function (e) {
    mouseX = e.clientX;
    mouseY = e.clientY;

    var target = e.target;
    var overInteractive = target.closest('[data-takeover-thumb-index]') ||
      target.closest('.product-gallery-takeover__buy') ||
      target.closest('.header__heading-link');

    if (isOpen && !overInteractive) {
      showCursor();
    } else {
      hideCursor();
    }
  });

  takeover.addEventListener('mouseleave', hideCursor);

  window.productGalleryTakeover = { open: open };
})();
